import { toast } from 'react-toastify';

// Configuraciones base para diferentes tipos de notificaciones
const defaultOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

// Notificaciones de éxito
export const showSuccessToast = (message, options = {}) => {
  toast.success(message, {
    ...defaultOptions,
    ...options,
  });
};

// Notificaciones de error
export const showErrorToast = (message, options = {}) => {
  toast.error(message, {
    ...defaultOptions,
    autoClose: 5000, // Los errores duran más tiempo
    ...options,
  });
};

// Notificaciones de advertencia
export const showWarningToast = (message, options = {}) => {
  toast.warning(message, {
    ...defaultOptions,
    ...options,
  });
};

// Notificaciones de información
export const showInfoToast = (message, options = {}) => {
  toast.info(message, {
    ...defaultOptions,
    ...options,
  });
};

// Notificación de carga (loading)
export const showLoadingToast = (message, options = {}) => {
  return toast.loading(message, {
    ...defaultOptions,
    autoClose: false, // No se cierra automáticamente
    ...options,
  });
};

// Actualizar notificación de carga
export const updateLoadingToast = (toastId, message, type = 'success', options = {}) => {
  const updateOptions = {
    ...defaultOptions,
    render: message,
    type: type,
    isLoading: false,
    autoClose: 3000,
    ...options,
  };
  
  toast.update(toastId, updateOptions);
};

// Mensajes predefinidos para acciones comunes
export const notifications = {
  // Acciones CRUD
  create: {
    success: (item) => `${item} creado exitosamente`,
    error: (item) => `Error al crear ${item}`,
  },
  update: {
    success: (item) => `${item} actualizado exitosamente`,
    error: (item) => `Error al actualizar ${item}`,
  },
  delete: {
    success: (item) => `${item} eliminado exitosamente`,
    error: (item) => `Error al eliminar ${item}`,
  },
  // Acciones específicas
  save: {
    success: 'Guardado exitosamente',
    error: 'Error al guardar',
  },
  load: {
    error: 'Error al cargar los datos',
  },
  search: {
    noResults: 'No se encontraron resultados',
    error: 'Error en la búsqueda',
  },
  // Acciones de autenticación
  auth: {
    loginSuccess: 'Inicio de sesión exitoso',
    loginError: 'Error al iniciar sesión',
    logoutSuccess: 'Sesión cerrada exitosamente',
  },
  // Acciones de archivo
  file: {
    uploadSuccess: 'Archivo subido exitosamente',
    uploadError: 'Error al subir el archivo',
    downloadError: 'Error al descargar el archivo',
  },
};
